<div *ngIf="global_texts && mod_info_explanation" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div>
        <div class="mt-5 mt-md-3 p-3 p-lg-5">
          <div class="d-flex">

            <div class="self-module mod-expl">

              <!-- Bubble Title -->
              <div class="bubble-step right mb-5"
                   [class.biggest-pad-top]="mod_info_explanation.title == titleCasComptoir1">
                <div class="title">
                  <h1 [innerHtml]="mod_info_explanation.title"></h1>
                </div>

                <div *ngIf="mod_info_explanation.type == ExplanationType.FlexColsTexte" class="w-100 px-0 px-lg-5">
                  <h4 class="text-bubble-step text-center"
                      [class.mb-5]="mod_info_explanation.text_flex_columns && mod_info_explanation.text_flex_columns.length > 0"
                      [innerHtml]="mod_info_explanation.text"></h4>
                </div>

                <!-- Bubble Content Explanation *ngIf="mod_info_explanation.type != ExplanationType.TwoColsTexte"-->
                <div
                  class="d-flex flex-column flex-lg-row flex-wrap justify-content-between gap-2 gap-md-5 px-0 px-lg-5"
                  [class.align-items-center]="mod_info_explanation.type == ExplanationType.ImageEtTexte">

                  <!-- ExplanationType : FlexColsTexte -->
                  <div [hidden]="mod_info_explanation.type != ExplanationType.FlexColsTexte" style="flex: 1;
                  max-width: 100%"
                       *ngFor="let text of mod_info_explanation.text_flex_columns"
                       class="rounded-5" [class.bg-lightest-grey]="!text.image && text.content">
                    <ng-container *ngTemplateOutlet="flexColsTexteTemplate; context: { data:
                      text, listTitle: mod_info_explanation.list_title }"></ng-container>
                  </div>

                  <!-- ExplanationType : ImageEtTexte-->
                  <div class="left-module bloc-image" *ngIf="mod_info_explanation.type ==
                  ExplanationType.ImageEtTexte && mod_info_explanation.image">
                    <!--px-5-->
                    <img class="" [src]="mod_info_explanation.image"/>
                  </div>

                  <!-- ExplanationType : not FlexColsTexte-->
                  <!--[ngClass]="{'px-0 px-lg-5': !mod_info_explanation.image}"-->
                  <div *ngIf="mod_info_explanation.type != ExplanationType.FlexColsTexte"
                       class="right-module justify-content-center align-items-center align-self-center">

                    <h4 class="text-bubble-step text-start" [innerHtml]="mod_info_explanation.text"></h4>

                    <div class="my-3" *ngIf="mod_info_explanation.type == ExplanationType.ImageEtTexte &&
                    mod_info_explanation.list_buttons">
                      <button *ngFor="let button of mod_info_explanation.list_buttons"
                              class="btn btn-solid-green btn-small d-flex gap-3 align-items-center"
                              (click)="openModalExplanation(button)">
                        <span class="material-icons fs-1">add_circle</span>
                        <span class="text-start small" [innerHtml]="button.title"></span>
                      </button>
                    </div>

                    <!-- ExplanationType : ImageFixePopUp -->
                    <div *ngIf="mod_info_explanation.type == ExplanationType.ImageFixePopUp"
                         class="mt-5">
                      <div class="bloc-image-btn-fixed position-relative">
                        <img class="image-btn-fixed" [src]="mod_info_explanation.image"/>

                        <a *ngFor="let button of mod_info_explanation.list_buttons"
                           [hidden]="!mod_info_explanation.list_buttons"
                           class="position-absolute btn btn-solid-green btn-more"
                           [style.top]="button.position?.top"
                           [style.left]="button.position?.left"
                           (click)="openModalExplanation(button)">
                          <span class="material-icons">add</span>
                        </a>
                      </div>

                    </div>

                    <!-- ExplanationType : ButtonsPopUp -->
                    <div *ngIf="mod_info_explanation.type == ExplanationType.ButtonsPopUp">
                      <div *ngFor="let group of list_buttons_keys" class="mt-5">

                        <h3 class="fw-bold">
                          <span [innerHtml]="mod_info_explanation.list_title"></span>
                          <span class="color-red text-uppercase" [innerHtml]="' ' + group"></span>
                        </h3>

                        <div
                          class="my-4 d-flex flex-column flex-lg-row flex-lg-wrap align-items-center justify-content-center gap-4">
                          <button *ngFor="let button of list_buttons.get(group)" style="flex: 0 auto; max-width: 100%;"
                                  (click)="openModalExplanation(button)"
                                  class="d-flex gap-2 align-items-center btn btn-lined-red btn-small text-lg-nowrap">
                            <svg class="fill-red" width="20" height="20">
                              <use xlink:href="#zoom"></use>
                            </svg>
                            <span class="" [innerHtml]="button.title"></span>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <!--Annexes -->
                <div *ngIf="current_screen_annexes" class="px-0 px-lg-5">
                  <app-annexes [annexes]="current_screen_annexes"></app-annexes>
                </div>

                <div class="mt-4 mt-lg-5 p-0 px-lg-5">
                  <!-- Asterisks -->
                  <div *ngIf="mod_info_explanation.asterisks && mod_info_explanation.asterisks.length > 0">
                    <app-asterisks [asterisks]="mod_info_explanation.asterisks"></app-asterisks>
                  </div>

                  <!-- Small Texts -->
                  <div *ngIf="current_screen_small_texts">
                    <app-small-texts [smallTexts]="current_screen_small_texts"></app-small-texts>
                  </div>
                </div>

                <div>
                  <!-- Button -->
                  <div class="mt-4 mt-lg-5 d-flex flex-column flex-lg-row gap-3 justify-content-center">
                    <button #buttonPrev *ngIf="has_button_previous" class="btn btn-solid-red text-uppercase mx-3"
                            (click)="app.sharedHelper.goToNextScreen('prev')"
                            [innerHtml]="global_texts.previous">
                    </button>
                    <button #buttonNext class="btn btn-solid-green text-uppercase mx-3"
                            (click)="app.sharedHelper.goToNextScreen()"
                            [innerHtml]="global_texts.next">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<ng-template #flexColsTexteTemplate let-data="data" let-listTitle="listTitle">
  <div [class.p-3]="data.image && data.content" [ngClass]="{'p-3 p-md-5' : !data.image && data.content}">
    <!-- Image [class.mb-4]="data.content || data.group || data.title" class="image-bloc-flex">-->
    <div *ngIf="data?.image" [ngClass]="{'mb-4 image-bloc-flex': data.content || data.group || data.title}">
      <img [src]="data?.image" class="img-fluid" alt="">
    </div>

    <!-- List-title + Group -->
    <div>
      <h3 class="fw-bold" *ngIf="data?.group">
        <span *ngIf="listTitle" [innerHtml]="listTitle"></span>
        <span class="text-uppercase" [innerHtml]="' ' + data?.group"></span>
      </h3>

      <!-- Title -->
      <h3 class="fw-bold" *ngIf="data?.title">
        <span class="color-red text-uppercase" [innerHtml]="' ' + data?.title"></span>
      </h3>

      <!-- Content -->
      <h5 class="p-0 p-md-3 mt-3" *ngIf="data?.content" [innerHtml]="data?.content"></h5>
    </div>
  </div>
</ng-template>

